import React from 'react'
import { Text, View, StyleSheet } from 'react-native'
import { useTranslation } from 'react-i18next'
import { Spacer } from '../../../ui/atoms'
import SModal from '../../../ui/molecules/SModal'
import { Divider } from 'react-native-paper'
import { commonColors } from '@linqpal/common-frontend/src/theme'
import {
  CardErrorType,
  CARD_ERROR_TYPE,
} from '@linqpal/models/src/dictionaries'

interface ErrorAlertProps {
  msg1: string
  msg2: string
  type: CardErrorType
  onClose: () => void
  action?: () => void
  visible: boolean
}

export const ErrorAlert: React.FC<ErrorAlertProps> = ({
  msg1,
  msg2,
  type,
  onClose,
  action,
  visible,
}) => {
  const { t } = useTranslation('global')
  return (
    <SModal
      backDropAction={false}
      onClose={onClose}
      visible={visible}
      containerStyle={{ padding: 0, width: 300 }}
      contentStyle={{ padding: 0 }}
    >
      <Spacer />
      <Spacer />
      <Text style={styles.msg1}>{msg1}</Text>
      <Spacer />
      <Text style={styles.msg2}>{msg2}</Text>
      <Spacer />
      <Spacer />
      <Divider />
      <View style={{ flexDirection: 'row' }}>
        {type === CARD_ERROR_TYPE.ADDRESS_MISMATCH && (
          <Text style={styles.goBack} onPress={action}>
            {t('AddCard.go-back')}
          </Text>
        )}
        <Text style={styles.addNew} onPress={onClose}>
          {t('AddCard.add-new-card')}
        </Text>
      </View>
    </SModal>
  )
}

const styles = StyleSheet.create({
  msg1: {
    fontWeight: 'bold',
    marginBottom: 3,
    width: '100%',
    textAlign: 'center',
    paddingHorizontal: 10,
    color: '#000',
    fontSize: 20,
  },
  msg2: {
    fontWeight: 'normal',
    width: '100%',
    textAlign: 'center',
    paddingHorizontal: 10,
    color: '#000',
    fontSize: 16,
  },
  addNew: {
    color: commonColors.accentText,
    fontSize: 17,
    fontWeight: '400',
    width: '100%',
    textAlign: 'center',
    paddingHorizontal: 10,
    paddingVertical: 12,
  },
  goBack: {
    color: commonColors.accentText,
    fontWeight: '600',
    fontSize: 17,
    width: '100%',
    textAlign: 'center',
    paddingHorizontal: 10,
    paddingVertical: 12,
    borderRightWidth: 1,
    borderRightColor: '#3c3c434d',
  },
})
